import { render, staticRenderFns } from "./FileUploadDetails.vue?vue&type=template&id=1264d4e0&"
import script from "./FileUploadDetails.vue?vue&type=script&lang=js&"
export * from "./FileUploadDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports